import { render, staticRenderFns } from "./WelcomeFinalPage.vue?vue&type=template&id=96b528c4&scoped=true"
import script from "./WelcomeFinalPage.vue?vue&type=script&lang=ts"
export * from "./WelcomeFinalPage.vue?vue&type=script&lang=ts"
import style0 from "./WelcomeFinalPage.vue?vue&type=style&index=0&id=96b528c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96b528c4",
  null
  
)

export default component.exports